// src/pages/meeting/MeetingLayout.jsx
import React from "react";
import { projectMenus } from "../../../components/layout/ProjectMenus";
import SidebarLayout from "../../../components/common/layout/SidebarLayout";

export default function MeetingLayout() {
  const { title, base, sections } = projectMenus.meeting;

  return <SidebarLayout title={title} base={base} sections={sections} />;
}
